<template>
  <v-footer
    app
    color="primary"
    class="d-print-none footer"
    elevation="5"
    height="40"
    padless
  >
    <v-container class="d-flex justify-end align-center container-footer py-0">
      <div class="copyright white--text">
        <small class="text-body-2">
          © {{ currentYear }} AV Securities Inc. All Rights Reserved.
        </small>
      </div>
    </v-container>
  </v-footer>
</template>
<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    heightFooter() {
      return this.$vuetify.breakpoint.smAndDown ? 40 : 40
    }
  }
}
</script>
